import { gql } from '@apollo/client';

export const PAGINATED_TEMPLATES = gql`
  query Templatesv2($input: PaginationFilterInput!) {
    templatesv2(input: $input) {
      item {
        ... on TemplatePaginatedResult {
          pageIndex
          pageSize
          totalItems
          totalPages
          hasPreviousPage
          hasNextPage
          data {
            id
            processId
            name
            created {
              date
              by
            }
            templateStatus
            isDefault
            visibility
          }
        }
        ... on TemplateQueryError {
          message
          code
        }
      }
    }
  }
`;
